/** @format */

const functionId = 'compare';
const functionIdCoupon = 'receiveNcoupon';
const appId = 'JDC_goodscontrast';
export { functionId, functionIdCoupon, appId };
